import { navigate } from "@reach/router";
import { useEffect } from "react";

/**
 * redirects from old urls:
 * 	account/431/request-for-quote/494/all/request-for-construction-services
 *  account/431/request-for-quote/view-rfx/494
 *
 * to:
 * 	account/431/rfx/494/
 *
 * @param param0
 * @returns
 */
const ClientViewRFxRedirect: React.FC<{
	companyId?: number;
	currentTab?: string;
	path: string;
	rfxId?: number;
	slug?: string;
}> = ({ companyId, currentTab, rfxId, slug, path }) => {
	useEffect(() => {
		if (!companyId || !rfxId) {
			return;
		}

		let redirectPath = `/account/${companyId}/rfx/${rfxId}/`;

		if (slug) {
			redirectPath += `${slug}/`;
		}

		if (currentTab) {
			redirectPath += `${currentTab}/`;
		}

		navigate(redirectPath, {
			replace: true,
		});
	}, [companyId, currentTab, rfxId, slug]);

	return null; // nothing to render
};

export default ClientViewRFxRedirect;
